import { COOKIE_CONSENT_CHANGED_EVENT, readConsent } from './cookieConsent';

declare global {
  interface Window {
    dataLayer?: unknown[];
    gtag?: (...args: unknown[]) => void;
  }
}

let initialized = false;

interface GtagConsentState {
  ad_storage: 'granted' | 'denied';
  ad_user_data: 'granted' | 'denied';
  ad_personalization: 'granted' | 'denied';
  analytics_storage: 'granted' | 'denied';
}

/**
 * Registra o Consent Mode v2 do Google com padrão "negado".
 * Enquanto o usuário não escolher, nenhuma tag de análise/ads grava cookies.
 */
export function initAnalytics(): void {
  if (typeof window === 'undefined' || initialized) {
    return;
  }
  initialized = true;

  window.dataLayer = window.dataLayer || [];
  const gtag: (...args: unknown[]) => void =
    window.gtag ??
    function gtagStub() {
      // Espelha o snippet oficial: repassa os argumentos para o dataLayer.
      window.dataLayer!.push(arguments);
    };
  window.gtag = gtag;

  gtag('consent', 'default', {
    ad_storage: 'denied',
    ad_user_data: 'denied',
    ad_personalization: 'denied',
    analytics_storage: 'denied',
    wait_for_update: 500,
  });

  window.addEventListener(COOKIE_CONSENT_CHANGED_EVENT, () => {
    applyAnalyticsConsent();
  });

  applyAnalyticsConsent();
}

/**
 * Sincroniza o Consent Mode com a escolha salva do usuário.
 * Chamado no carregamento e sempre que o consentimento muda.
 */
export function applyAnalyticsConsent(): void {
  if (typeof window === 'undefined') {
    return;
  }

  const gtag = window.gtag;
  if (typeof gtag !== 'function') {
    return;
  }

  const consent = readConsent();
  const analyticsGranted = Boolean(consent?.analytics);
  const marketingGranted = Boolean(consent?.marketing);

  const state: GtagConsentState = {
    analytics_storage: analyticsGranted ? 'granted' : 'denied',
    ad_storage: marketingGranted ? 'granted' : 'denied',
    ad_user_data: marketingGranted ? 'granted' : 'denied',
    ad_personalization: marketingGranted ? 'granted' : 'denied',
  };

  gtag('consent', 'update', state);
}